import React, { useMemo } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { CSSTransition } from 'react-transition-group';

import Box from '@rexlabs/box';
import { Heading } from '@rexlabs/text';
import { styled, StyleSheet } from '@rexlabs/styling';

import Form from '../forms/Form';
import './styles.css';

const primaryColor = getComputedStyle(
  document.documentElement
).getPropertyValue('--brand_primary_color');

const defaultStyles = StyleSheet({
  closeBtn: {
    fontSize: '4rem',
    cursor: 'pointer'
  },
  titleContainer: {
    padding: '1.5rem',
    borderBottom: '1px solid black'
  },
  button: {
    borderColor: primaryColor,
    backgroundColor: primaryColor,
    ':hover': {
      borderColor: primaryColor,
      backgroundColor: primaryColor
    },
    ':active': {
      borderColor: primaryColor,
      backgroundColor: primaryColor
    }
  }
});

function StandardPopup({ popup, closeModal, styles: s, showing, animation }) {
  const width = useMemo(() => {
    switch (popup?.width) {
      case 'small':
        return '40%';
      case 'medium':
        return '65%';
      default:
        return '80%';
    }
  }, [popup]);

  return (
    <CSSTransition
      unmountOnExit
      in={showing}
      timeout={200}
      classNames={animation}
      onEnter={null}
      onExiting={null}
    >
      <div className={'modal-container'}>
        <div className={'modal-content'} style={{ width: width }}>
          <Box flexDirection={'column'}>
            {popup?.title && (
              <Box
                {...s('titleContainer')}
                flexDirection={'row'}
                justifyContent={'space-between'}
              >
                <Heading className='font-size-large weight-bold'>
                  {popup?.title}
                </Heading>
                <Heading {...s('closeBtn')} onClick={closeModal}>
                  &times;
                </Heading>
              </Box>
            )}

            <Box p={10}>
              {popup?.content && (
                <Box>
                  {/* TODO: Add base styles using transform */}
                  {ReactHtmlParser(popup?.content)}
                </Box>
              )}

              {popup?.form_id && (
                <Form websiteId={popup.website_id} formId={popup.form_id} />
              )}
            </Box>
            {/* <Box p={10}> */}
            {/*  <PrimaryButton {...s('button')} onClick={closeModal}>Close</PrimaryButton> */}
            {/* </Box> */}
          </Box>
        </div>
        <div className={'modal-cover'} onClick={closeModal} />
      </div>
    </CSSTransition>
  );
}

export default styled(defaultStyles)(StandardPopup);
